import { RESTproxy } from '../RESTproxy';
import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

const errorOf = async (res) => {
    const body = await res.json().catch(() => ({}));
    return new Error(body.error || res.statusText || `HTTP ${res.status}`);
};

export class CategoriesProxy extends RESTproxy {
    constructor() {
        super('category');
    }

    /** Sanitizes and stores an SVG on the assets CDN; the returned url goes into the category's `iconUrl`. */
    async uploadIcon(file) {
        const formData = new FormData();
        formData.append('file', file);
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/category/icon`, {
            method: 'POST',
            body: formData,
        });
        if (!res.ok) throw await errorOf(res);
        return res.json();
    }

    /** Partial update: only the keys sent change. */
    async update(id, fields) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/category/${id}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(fields),
        });
        if (!res.ok) throw await errorOf(res);
        return res.json();
    }

    async listSchedules(categoryId) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/category/schedules?categoryId=${encodeURIComponent(categoryId)}`);
        if (!res.ok) throw await errorOf(res);
        return res.json();
    }

    /** Creates a timed change, or edits one when `id` is given (a live one only moves its end). */
    async saveSchedule(id, body) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/category/schedules${id ? `/${id}` : ''}`, {
            method: id ? 'PUT' : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!res.ok) throw await errorOf(res);
        return res.json();
    }

    /** Cancels a schedule that has not started, or takes back a live one now. */
    async cancelSchedule(id) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/category/schedules/${id}/cancel`, { method: 'POST' });
        if (!res.ok) throw await errorOf(res);
        return res.json();
    }

    async create(data) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/category`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        if (!res.ok) throw await errorOf(res);
        return res.text();
    }
}
